import { Icon } from '@rbilabs/universal-components';

import { PressableItemCard } from 'components/quests/components/pressable-item-card';
import { primitive } from 'styles/constants';
export const PressableItem = PressableItemCard.withConfig(p => ({
  borderRadius: 'lg',
  overflow: 'visible',
  minHeight: '72px',
  background: primitive.$white,
}));

export const CompletedStepIcon = Icon.withConfig({
  variant: 'checkFill',
  color: primitive.$crunchyGreen,
});

export const UncompletedStepIcon = Icon.withConfig({
  variant: 'forward',
});
